var modules_034cfbf6 = {"container":"_zem5pp","qrWrapper":"_9hirnn","titleContainer":"_11myrxo","appImg":"_5pcqd8","stub":"_1q2b64b"};
import "../../../assets/886lZeXV.css";

export { modules_034cfbf6 as default };
//# sourceMappingURL=AppBanner.module.less.js.map
